import errorSvg from "src/img/sad-robot.svg";
import errorPng from "src/img/sad-robot.png";

export default function ErrorImage() {
  return (
    <picture>
      <source srcSet={errorSvg} type="image/svg+xml" />
      <img src={errorPng} alt="Something went wrong..." aria-hidden />
    </picture>
  );
}
